import { LocaleId, TranslationDictionaryMapping } from '@domgen/dgx-fe-i18n';
import { FeatureCardTranslationDictionary } from '../models/i18n/feature-card-translation-dictionary.interface';

export const featureCardTranslationDictionaryMapping: TranslationDictionaryMapping<FeatureCardTranslationDictionary> =
  {
    [LocaleId.English_GreatBritain]: {
      CARD_FORM_ACCOUNT_NAME_ERROR_ALPHABETICAL:
        'Please enter an alphabetical value',
      CARD_FORM_ACCOUNT_NAME_ERROR_MAX_LENGTH:
        'Please enter a value that is no more than {{ maxLength }} characters',
      CARD_FORM_ACCOUNT_NAME_ERROR_MIN_LENGTH:
        'Please enter a value that is at least {{ minLength }} characters',
      CARD_FORM_ACCOUNT_NAME_ERROR_REQUIRED: 'Please enter a first name',
      CARD_FORM_CARD_NUMBER_ERROR_REQUIRED: 'Please provide a card number',
      CARD_FORM_CVV_ERROR_REQUIRED: 'Please provide a cvv number',
      CARD_FORM_EXPIRY_DATE_ERROR_REQUIRED: 'Please provide an expiry date',
      CARD_FORM_MONTHLY_RENEWAL_ERROR_REQUIRED:
        'Please tick the box above to proceed with your registration and plan purchase.',
      CARD_FORM_SUBMIT: 'Confirm & Pay securely',
      CARD_FORM_TERMS_AND_CONDITIONS_ERROR_REQUIRED:
        'Please tick the box to confirm you have read the Insurance Product Information Document',
    },
    [LocaleId.English_Ireland]: {
      CARD_FORM_ACCOUNT_NAME_ERROR_ALPHABETICAL:
        'Please enter an alphabetical value',
      CARD_FORM_ACCOUNT_NAME_ERROR_MAX_LENGTH:
        'Please enter a value that is no more than {{ maxLength }} characters',
      CARD_FORM_ACCOUNT_NAME_ERROR_MIN_LENGTH:
        'Please enter a value that is at least {{ minLength }} characters',
      CARD_FORM_ACCOUNT_NAME_ERROR_REQUIRED: 'Please enter a first name',
      CARD_FORM_CARD_NUMBER_ERROR_REQUIRED: 'Please provide a card number',
      CARD_FORM_CVV_ERROR_REQUIRED: 'Please provide a cvv number',
      CARD_FORM_EXPIRY_DATE_ERROR_REQUIRED: 'Please provide an expiry date',
      CARD_FORM_MONTHLY_RENEWAL_ERROR_REQUIRED:
        'Please tick the box above to proceed with your registration and plan purchase.',
      CARD_FORM_SUBMIT: 'Confirm & Pay securely',
      CARD_FORM_TERMS_AND_CONDITIONS_ERROR_REQUIRED:
        'Please tick the box to confirm you have read the Insurance Product Information Document',
    },
    [LocaleId.English_US]: {
      CARD_FORM_ACCOUNT_NAME_ERROR_ALPHABETICAL:
        'Please enter an alphabetical value',
      CARD_FORM_ACCOUNT_NAME_ERROR_MAX_LENGTH:
        'Please enter a value that is no more than {{ maxLength }} characters',
      CARD_FORM_ACCOUNT_NAME_ERROR_MIN_LENGTH:
        'Please enter a value that is at least {{ minLength }} characters',
      CARD_FORM_ACCOUNT_NAME_ERROR_REQUIRED: 'Please enter a first name',
      CARD_FORM_CARD_NUMBER_ERROR_REQUIRED: 'Please provide a card number',
      CARD_FORM_CVV_ERROR_REQUIRED: 'Please provide a cvv number',
      CARD_FORM_EXPIRY_DATE_ERROR_REQUIRED: 'Please provide an expiry date',
      CARD_FORM_MONTHLY_RENEWAL_ERROR_REQUIRED:
        'Please tick the box above to proceed with your registration and plan purchase.',
      CARD_FORM_SUBMIT: 'Confirm & Pay securely',
      CARD_FORM_TERMS_AND_CONDITIONS_ERROR_REQUIRED:
        'Please tick the box to confirm you have read the Insurance Product Information Document',
    },
  };
